import React, { useMemo } from 'react';
import { ListingCard } from '../../../components';
import Slider from 'react-slick';

import css from './Section.module.css';
import '../../../styles/slick/slick-theme.css';
import '../../../styles/slick/slick.css';
import { isArrayLength } from '../../../util/genericHelpers';
import classNames from 'classnames';

function SectionAuctionListings(props) {
  const { intl, sliderSettings: sliderSettingsProp, listings = [], user } = props;

  // ✅ Filter only auction listings
  const auctionListings = useMemo(() => {
    return (listings || []).filter(l => {
      const publicData = l?.attributes?.publicData || {};
      return publicData?.isAuction === true;
    });
  }, [listings]);

  // Detect mobile safely
  const isWindowDefined = typeof window !== 'undefined';
  const isMobileLayout = isWindowDefined && window.innerWidth < 768;

  // ✅ Slider settings (NO nested hooks)
  const sliderSettings = useMemo(() => {
    const base = SectionAuctionListings.defaultProps.sliderSettings;

    const merged = {
      ...base,
      ...(sliderSettingsProp || {}),
      responsive: sliderSettingsProp?.responsive || base.responsive,
    };

    // ✅ Hard-force mobile layout
    if (isMobileLayout) {
      Object.assign(merged, {
        dots: false,
        arrows: false,
        slidesToShow: 1.2,
        slidesToScroll: 1,
        centerMode: false,
        variableWidth: false,
      });
    }

    return merged;
  }, [sliderSettingsProp, isMobileLayout]);

  // ⛔ Don’t render section if no auction listings
  if (!isArrayLength(auctionListings)) {
    return null;
  }

  return (
    <div className={classNames(css.popularSessions, css.auctionListings)}>
      <div className={css.fixedWidthContainer}>
        <div className={css.sectionHead}>
          <h2>Timed Sales</h2>
        </div>

        <div className={css.listingSlider}>
          <Slider {...sliderSettings}>
            {auctionListings.map(l => (
              <div key={l?.id?.uuid} style={{ height: '100%' }}>
                <ListingCard
                  user={user}
                  className={css.listingCard}
                  listing={l}
                  setActiveListing={() => {}}
                />
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </div>
  );
}

SectionAuctionListings.defaultProps = {
  sliderSettings: {
    dots: false,
    arrows: true,
    infinite: false,
    autoplay: false,
    autoplaySpeed: 2000,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    variableWidth: false,
    focusOnSelect: false,
    centerMode: false,
    responsive: [
      { breakpoint: 1500, settings: { slidesToShow: 4 } },
      { breakpoint: 1300, settings: { slidesToShow: 3 } },
      { breakpoint: 992, settings: { slidesToShow: 2 } },
      { breakpoint: 580, settings: { slidesToShow: 1.5, slidesToScroll: 1 } },
      { breakpoint: 480, settings: { slidesToShow: 1.2, slidesToScroll: 1 } },
    ],
  },
};

export default SectionAuctionListings;
